import React from 'react';

const Footer = () => {
  return (
    <footer className="py-8 border-t border-border">
      <div className="max-w-screen-xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-textlight">
          &copy; {new Date().getFullYear()} Safia Djenane. All rights reserved.
        </p>
        <p className="text-sm text-textlight">
          Made with <span className="text-primary">&#9829;</span> by Safia Djenane
        </p>
      </div>
    </footer>
  );
};

export default Footer;
